<template>
  <div :style="{ width }">
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
      <CSelect
              :invalidFeedback="errors[0]"
              :name="name"
              :value.sync="localValue"
              :isValid="errors[0] ? false : null"
              :options="options"
              placeholder="---"
      ></CSelect>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      default: "text"
    },
    valueKey: {
      type: String,
      default: "value"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    limit: {
      type: Number,
      default: null
    },
    width: {
      type: String,
      default: "200px"
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    checkLimit(selections) {
      if (this.multiple && this.limit > 1 && selections.length > this.limit) {
        selections.splice(this.limit);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.select-field {
  font-size: 13px;
}
</style>
